export default "__VITE_ASSET__DplP01Jy__"